import { genericService } from "./genericService";
import { akeronService } from "./akeronService";
import { requestService } from "./requestService";

const paises_api_url = process.env.VUE_APP_PAISES_API_URL;
const timeout = 30000; //ms

function getAll() {
  return requestService.make_get_request(paises_api_url, timeout, "Country/ListAllCountry");
}

function getAllProvince(country) {
  return requestService.make_get_request(paises_api_url, timeout, "Province/ListAllProvince/" + country);
}

function getAllLocality(province, country) {
  return requestService.make_get_request(paises_api_url, timeout, "Locality/ListAllLocality/" + province + "/" + country);
}

function getProvinceDeliveryPending() {
  return genericService.get("Province/ProvinceWithDeliveryPending/");
}
function getLocalityDeliveryPending(id) {
  var array = [];
  array.push(id);
  return akeronService
    .make_post_request("Locality/LocalityWithDeliveryPending", {
      provinces: array,
    })
    .then((response) => {
      return response;
    });
}

export const countryService = {
  getAll,
  getAllProvince,
  getAllLocality,
  getProvinceDeliveryPending,
  getLocalityDeliveryPending,
};
